export default [
  // 直销跟单详情(正向)
  {
    path: '/zhixiao/direct-sales-delivery-manage/direct-sales-delivery/detail',
    name: 'ZhiXiaoDirectSalesDeliveryDetail',
    component: () => import(/* webpackChunkName: 'ZhiXiaoDirectSalesDeliveryDetail' */ '@/views/zhixiao/direct-sales-delivery-manage/direct-sales-delivery/detail.vue'),
  },
  // 大客户、备货、销售跟单详情
  {
    path: '/zhixiao/delivery-task/detail',
    name: 'ZhiXiaoDeliveryTaskDetail',
    component: () => import(/* webpackChunkName: 'ZhiXiaoDeliveryTaskDetail' */ '@/views/zhixiao/delivery-task/detail.vue'),
  },

  // 跟单售后-客退任务
  {
    path: '/zhixiao/after-sales-delivery/customer-return',
    name: 'ZhiXiaoAfterSalesDeliveryCustomerReturn',
    component: () => import(/* webpackChunkName: 'ZhiXiaoAfterSalesDelivery' */ '@/views/zhixiao/direct-sales-delivery-manage/after-sales-delivery/customer-return/detail.vue'),
  },
  // 跟单售后-退供任务 
  {
    path: '/zhixiao/after-sales-delivery/return-supplier',
    name: 'ZhiXiaoAfterSalesDeliveryReturnSupplier',
    component: () => import(/* webpackChunkName: 'ZhiXiaoAfterSalesDelivery' */ '@/views/zhixiao/direct-sales-delivery-manage/after-sales-delivery/return-supplier/detail.vue'),
  },
  // 贴纸扫码后，预览质检报告+疵点图片
  {
    path: '/delivery-task/preview-inspection-report',
    name: 'PreviewInspectionReport',
    component: () => import(/* webpackChunkName: 'ZhiXiaoDeliveryTaskDetail' */ '@/views/zhixiao/delivery-task/preview-inspection-report.vue'),
  },
  // 直销APP登录帮助
  {
    path: '/zhixiao/login-help',
    name: 'ZhiXiaoLoginHelp',
    component: () => import(/* webpackChunkName: 'ZhiXiaoLoginHelp' */ '@/views/zhixiao/login/help.vue'),
  },
  // 直销跟单详情(正向)
  {
    path: '/zhixiao/direct-sales-delivery-manage/direct-sales-delivery/inspection-report',
    name: 'ZhiXiaoDirectSalesDeliveryInsperction',
    component: () => import(/* webpackChunkName: 'ZhiXiaoDirectSalesDeliveryDetail' */ '@/views/zhixiao/direct-sales-delivery-manage/direct-sales-delivery/inspection-report/index.vue'),
  },
];
